import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/resources/_components/ClientSideResourceWrapper/ClientSideResourcesWrapper.tsx");
